/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CommentResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeExceptionMinutesResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeTimeCardResponse } from '../api-models';
// @ts-ignore
import { LastClockSyncResponseV2 } from '../api-models';
// @ts-ignore
import { OpenShiftsBusinessObjectsResponseTimeCardSchedulePlaceholderResponseV2 } from '../api-models';
// @ts-ignore
import { PayDateGroupEntry } from '../api-models';
// @ts-ignore
import { PayPeriodApprovalButtonPropertiesResponseV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ReCalculateTimecardRequestV2 } from '../api-models';
// @ts-ignore
import { RecalculateButtonStateResponseV2 } from '../api-models';
// @ts-ignore
import { SchedulePlaceholderAddRequestV2 } from '../api-models';
// @ts-ignore
import { SchedulePlaceholderPaymentStatusUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { SchedulePlaceholderUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { TimeCardCommentAddRequestV2 } from '../api-models';
// @ts-ignore
import { TimeCardDefinitionsResponse } from '../api-models';
/**
 * TimeCardApi - axios parameter creator
 * @export
 */
export const TimeCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Per-exception-type counts for a given pay date. Replaces taApi  `GET /api/TimeCard/DailyExceptionCounts`.
         * @param {string} [date]
         * @param {number} [graceMinutes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardDailyExceptionCountsGet: async (date?: string, graceMinutes?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/daily-exception-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (graceMinutes !== undefined) {
                localVarQueryParameter['graceMinutes'] = graceMinutes;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Per-employee exception details for a given (exception type, pay date). Replaces  taApi `GET /api/TimeCard/DailyExceptionDetails`.
         * @param {number} [exceptionTypeId]
         * @param {string} [date]
         * @param {number} [graceMinutes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardDailyExceptionDetailsGet: async (exceptionTypeId?: number, date?: string, graceMinutes?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/daily-exception-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (exceptionTypeId !== undefined) {
                localVarQueryParameter['exceptionTypeId'] = exceptionTypeId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (graceMinutes !== undefined) {
                localVarQueryParameter['graceMinutes'] = graceMinutes;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the static and configuration-based definitions used to render a time card:  the department labor-level designation plus dictionaries of exception, hour, and  comment types. Replaces the legacy  `/api/EntityList/{LaborLevelDesignations,ExceptionTypes,HoursTypes,CommentTypes}`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardDefinitionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the consolidated time-card payload (punches, hours, exceptions, comments,  holidays) for a single employee within the supplied date range. Falls back to the  working pay period when start/end are omitted. Replaces the legacy  `/api/Punch`, `/api/Hour`, `/api/Hour/OtherHours`,  `/api/Hour/OtherHoursForActualDate`, `/api/Employee/EmployeeHolidays`,  `/api/Exceptions`, and `/api/TimeCard/PayDateComment` endpoints.  Each entry in `PunchNotifications` carries a !:PunchNotificationType.  `CalculationNotes` (SPD-5625) is filled for manager-bucket callers only; an employee  viewing their own card gets an empty list.
         * @param {number} employeeId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {boolean} [hideWorkedHours]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardEmployeeIdGet: async (employeeId: number, startDate?: string, endDate?: string, hideWorkedHours?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2TimecardEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/timecard/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (hideWorkedHours !== undefined) {
                localVarQueryParameter['hideWorkedHours'] = hideWorkedHours;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the same pay-period data as `GET /api/v2/timecard/{employeeId}`  reorganised as a dictionary keyed by pay date (`yyyy-MM-dd`). Each value is the  list of punch-group entries on that date — one per distinct `PunchGroupNumber`.  Within an entry the hours carry every `HoursType` except dollar-amount entries  (`Dollars` = 99); set `HideWorkedHours` to also suppress worked Other-Hours  (`OtherHoursWorked` = 25). The exceptions are restricted to  `ScheduleWOPunches` = 5 and `MissingPunch` = 6. Each entry\'s  `placeholders` (SPD-5412) carries schedule placeholders for the date (e.g.  legacy-created absences); since placeholders have no punch group they only appear on  the group-0 (ungrouped) entry. Falls back to the working pay period when start/end are  omitted. Each entry in `PunchNotifications` carries a !:PunchNotificationType.
         * @param {number} employeeId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {boolean} [hideWorkedHours]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardEmployeeIdGroupByPayDateGet: async (employeeId: number, startDate?: string, endDate?: string, hideWorkedHours?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2TimecardEmployeeIdGroupByPayDateGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/timecard/{employeeId}/groupByPayDate`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (hideWorkedHours !== undefined) {
                localVarQueryParameter['hideWorkedHours'] = hideWorkedHours;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns when punch data was last synced from the facility\'s time clocks (SPD-5401):  the newest LegacyApp `TimeClock/Poll` audit row, falling back to the newest  `RawPunch` download stamp. Facility-wide (no employee id — the value is facility  metadata), SQL-server local time. `lastSyncedFromClock` is `null` when the  facility has never polled a clock. Net-new endpoint; no TaAPI counterpart exists  (TaAPI has no poll surface).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardLastClockSyncGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/last-clock-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft-delete a pay-date comment by id, asserting it belongs to the supplied  employee. Replaces taApi `DELETE /api/TimeCard/PayDateComment`.
         * @param {number} [employeeId]
         * @param {number} [commentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayDateCommentDelete: async (employeeId?: number, commentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/pay-date-comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (commentId !== undefined) {
                localVarQueryParameter['commentId'] = commentId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns PayDate comments in the supplied [start, end] range. Replaces taApi  `GET /api/TimeCard/PayDateComment`.
         * @param {number} [employeeId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayDateCommentGet: async (employeeId?: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/pay-date-comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add (or replace / append) the pay-date comment for the (employee, pay date)  pair. Replaces taApi `POST /api/TimeCard/PayDateComment`.
         * @param {TimeCardCommentAddRequestV2} [timeCardCommentAddRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayDateCommentPost: async (timeCardCommentAddRequestV2?: TimeCardCommentAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/pay-date-comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeCardCommentAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary UI-helper: visible/enabled/label state for the pay-period approval button.  Replaces taApi `GET /api/TimeCard/PayPeriodApprovalButtonProperties/{employeeId}`.
         * @param {number} employeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/timecard/pay-period-approval-button/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Approve the working pay period at the caller\'s TimeCardApprovalLevel. Returns  the post-action button-properties shape. Replaces taApi  `POST /api/TimeCard/PayPeriodApproval/{employeeId}`.
         * @param {number} employeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodApprovalEmployeeIdPost: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2TimecardPayPeriodApprovalEmployeeIdPost', 'employeeId', employeeId)
            const localVarPath = `/api/v2/timecard/pay-period-approval/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the caller\'s pay-period comment for the (employee, pay-period start)  pair, or 204 No Content when none. Replaces taApi  `GET /api/TimeCard/PayPeriodComment`.
         * @param {number} [employeeId]
         * @param {string} [startDateOfPayPeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodCommentGet: async (employeeId?: number, startDateOfPayPeriod?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/pay-period-comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDateOfPayPeriod !== undefined) {
                localVarQueryParameter['startDateOfPayPeriod'] = (startDateOfPayPeriod as any instanceof Date) ?
                    (startDateOfPayPeriod as any).toISOString() :
                    startDateOfPayPeriod;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add (or replace / append) the pay-period comment for the (employee, pay-period  start date) pair. Replaces taApi `POST /api/TimeCard/PayPeriodComment`.
         * @param {TimeCardCommentAddRequestV2} [timeCardCommentAddRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodCommentPost: async (timeCardCommentAddRequestV2?: TimeCardCommentAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/pay-period-comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeCardCommentAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Change a placeholder\'s OtherHours payment status. Transitioning to Approved creates the  linked OtherHours row (honouring the optional Minutes override + the PayTypesForHours and  accrual-balance gates); any other status removes the linked row; the stored status set again  is a no-op. Ports LegacyApp  `OtherHoursForm.placeholdersGrid_CellValueChanged` (OtherHoursForm.cs:1318-1427); the  legacy WinApp had no equivalent web/TaAPI endpoint.
         * @param {number} placeholderId
         * @param {SchedulePlaceholderPaymentStatusUpdateRequestV2} [schedulePlaceholderPaymentStatusUpdateRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut: async (placeholderId: number, schedulePlaceholderPaymentStatusUpdateRequestV2?: SchedulePlaceholderPaymentStatusUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placeholderId' is not null or undefined
            assertParamExists('apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut', 'placeholderId', placeholderId)
            const localVarPath = `/api/v2/timecard/placeholder/{placeholderId}/payment-status`
                .replace(`{${"placeholderId"}}`, encodeURIComponent(String(placeholderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulePlaceholderPaymentStatusUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add a new schedule placeholder for the employee. Replaces taApi  `POST /api/TimeCard/PlaceHolder`.
         * @param {SchedulePlaceholderAddRequestV2} [schedulePlaceholderAddRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholderPost: async (schedulePlaceholderAddRequestV2?: SchedulePlaceholderAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/placeholder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulePlaceholderAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edit a placeholder\'s payment status from the Other Hours window (SPD-5725); only the  transition from the stored status acts, and pay type and hours apply when approving. A save  that sends the status the row was loaded with gets 409 when that status moved meanwhile.  Approving converts the  placeholder into an OtherHours row on the timecard; moving the status away from Approved  removes the linked row again. Mirrors the LegacyApp Other Hours window\'s placeholders grid  (OtherHoursForm.cs:1318-1427). Authorization matches the sibling placeholder endpoints:  class-level CustomJwt plus the service-level facility-role gates (HoursAdd + HoursDelete +  PlaceholderOtherHoursPaymentStatusType) — a caller with no facility authorization resolves a  null role there and gets 403.
         * @param {SchedulePlaceholderUpdateRequestV2} [schedulePlaceholderUpdateRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholderPut: async (schedulePlaceholderUpdateRequestV2?: SchedulePlaceholderUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/placeholder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulePlaceholderUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule placeholders for the supplied employee. The list is pay-period-scoped  (legacy contract): StartDate/EndDate select WHICH period(s) — they are snapped  outward to full pay-period boundaries, so any date inside the viewed period returns  the whole period. Omitting both defaults to the working pay period. Replaces taApi  `GET /api/TimeCard/PlaceHolder/{employeeId}`.
         * @param {number} employeeId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {boolean} [payableWithOtherHoursOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholdersEmployeeIdGet: async (employeeId: number, startDate?: string, endDate?: string, payableWithOtherHoursOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2TimecardPlaceholdersEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/timecard/placeholders/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (payableWithOtherHoursOnly !== undefined) {
                localVarQueryParameter['payableWithOtherHoursOnly'] = payableWithOtherHoursOnly;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary UI-helper: returns whether the \"Recalculate\" button on the timecard main tab should  be enabled for the supplied (employee, pay-period). Replaces the legacy TaAPI  `PATCH /api/Employee/{id}/WorkingPayPeriod/{pkPayPeriodId}` — the FE only consumed  `isEnabled` from that response, and the PATCH\'s in-memory working-pay-period  side effect has no equivalent in stateless SaaSAPI.
         * @param {number} employeeId
         * @param {number} payPeriodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet: async (employeeId: number, payPeriodId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet', 'employeeId', employeeId)
            // verify required parameter 'payPeriodId' is not null or undefined
            assertParamExists('apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet', 'payPeriodId', payPeriodId)
            const localVarPath = `/api/v2/timecard/recalculate-button/{employeeId}/{payPeriodId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"payPeriodId"}}`, encodeURIComponent(String(payPeriodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Trigger a full timecard recompute for the supplied employee. Replaces taApi  `POST /api/TimeCard/ReCalculateTimecard`.
         * @param {ReCalculateTimecardRequestV2} [reCalculateTimecardRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardRecomputePost: async (reCalculateTimecardRequestV2?: ReCalculateTimecardRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timecard/recompute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reCalculateTimecardRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeCardApi - functional programming interface
 * @export
 */
export const TimeCardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeCardApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Per-exception-type counts for a given pay date. Replaces taApi  `GET /api/TimeCard/DailyExceptionCounts`.
         * @param {string} [date]
         * @param {number} [graceMinutes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardDailyExceptionCountsGet(date?: string, graceMinutes?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardDailyExceptionCountsGet(date, graceMinutes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Per-employee exception details for a given (exception type, pay date). Replaces  taApi `GET /api/TimeCard/DailyExceptionDetails`.
         * @param {number} [exceptionTypeId]
         * @param {string} [date]
         * @param {number} [graceMinutes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardDailyExceptionDetailsGet(exceptionTypeId?: number, date?: string, graceMinutes?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeExceptionMinutesResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardDailyExceptionDetailsGet(exceptionTypeId, date, graceMinutes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Returns the static and configuration-based definitions used to render a time card:  the department labor-level designation plus dictionaries of exception, hour, and  comment types. Replaces the legacy  `/api/EntityList/{LaborLevelDesignations,ExceptionTypes,HoursTypes,CommentTypes}`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardDefinitionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeCardDefinitionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardDefinitionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Returns the consolidated time-card payload (punches, hours, exceptions, comments,  holidays) for a single employee within the supplied date range. Falls back to the  working pay period when start/end are omitted. Replaces the legacy  `/api/Punch`, `/api/Hour`, `/api/Hour/OtherHours`,  `/api/Hour/OtherHoursForActualDate`, `/api/Employee/EmployeeHolidays`,  `/api/Exceptions`, and `/api/TimeCard/PayDateComment` endpoints.  Each entry in `PunchNotifications` carries a !:PunchNotificationType.  `CalculationNotes` (SPD-5625) is filled for manager-bucket callers only; an employee  viewing their own card gets an empty list.
         * @param {number} employeeId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {boolean} [hideWorkedHours]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardEmployeeIdGet(employeeId: number, startDate?: string, endDate?: string, hideWorkedHours?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardEmployeeIdGet(employeeId, startDate, endDate, hideWorkedHours, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Returns the same pay-period data as `GET /api/v2/timecard/{employeeId}`  reorganised as a dictionary keyed by pay date (`yyyy-MM-dd`). Each value is the  list of punch-group entries on that date — one per distinct `PunchGroupNumber`.  Within an entry the hours carry every `HoursType` except dollar-amount entries  (`Dollars` = 99); set `HideWorkedHours` to also suppress worked Other-Hours  (`OtherHoursWorked` = 25). The exceptions are restricted to  `ScheduleWOPunches` = 5 and `MissingPunch` = 6. Each entry\'s  `placeholders` (SPD-5412) carries schedule placeholders for the date (e.g.  legacy-created absences); since placeholders have no punch group they only appear on  the group-0 (ungrouped) entry. Falls back to the working pay period when start/end are  omitted. Each entry in `PunchNotifications` carries a !:PunchNotificationType.
         * @param {number} employeeId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {boolean} [hideWorkedHours]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardEmployeeIdGroupByPayDateGet(employeeId: number, startDate?: string, endDate?: string, hideWorkedHours?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<PayDateGroupEntry>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardEmployeeIdGroupByPayDateGet(employeeId, startDate, endDate, hideWorkedHours, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Returns when punch data was last synced from the facility\'s time clocks (SPD-5401):  the newest LegacyApp `TimeClock/Poll` audit row, falling back to the newest  `RawPunch` download stamp. Facility-wide (no employee id — the value is facility  metadata), SQL-server local time. `lastSyncedFromClock` is `null` when the  facility has never polled a clock. Net-new endpoint; no TaAPI counterpart exists  (TaAPI has no poll surface).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardLastClockSyncGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastClockSyncResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardLastClockSyncGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Soft-delete a pay-date comment by id, asserting it belongs to the supplied  employee. Replaces taApi `DELETE /api/TimeCard/PayDateComment`.
         * @param {number} [employeeId]
         * @param {number} [commentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayDateCommentDelete(employeeId?: number, commentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayDateCommentDelete(employeeId, commentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Returns PayDate comments in the supplied [start, end] range. Replaces taApi  `GET /api/TimeCard/PayDateComment`.
         * @param {number} [employeeId]
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayDateCommentGet(employeeId?: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommentResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayDateCommentGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add (or replace / append) the pay-date comment for the (employee, pay date)  pair. Replaces taApi `POST /api/TimeCard/PayDateComment`.
         * @param {TimeCardCommentAddRequestV2} [timeCardCommentAddRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayDateCommentPost(timeCardCommentAddRequestV2?: TimeCardCommentAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayDateCommentPost(timeCardCommentAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary UI-helper: visible/enabled/label state for the pay-period approval button.  Replaces taApi `GET /api/TimeCard/PayPeriodApprovalButtonProperties/{employeeId}`.
         * @param {number} employeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayPeriodApprovalButtonPropertiesResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Approve the working pay period at the caller\'s TimeCardApprovalLevel. Returns  the post-action button-properties shape. Replaces taApi  `POST /api/TimeCard/PayPeriodApproval/{employeeId}`.
         * @param {number} employeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayPeriodApprovalEmployeeIdPost(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayPeriodApprovalButtonPropertiesResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayPeriodApprovalEmployeeIdPost(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Returns the caller\'s pay-period comment for the (employee, pay-period start)  pair, or 204 No Content when none. Replaces taApi  `GET /api/TimeCard/PayPeriodComment`.
         * @param {number} [employeeId]
         * @param {string} [startDateOfPayPeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayPeriodCommentGet(employeeId?: number, startDateOfPayPeriod?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayPeriodCommentGet(employeeId, startDateOfPayPeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add (or replace / append) the pay-period comment for the (employee, pay-period  start date) pair. Replaces taApi `POST /api/TimeCard/PayPeriodComment`.
         * @param {TimeCardCommentAddRequestV2} [timeCardCommentAddRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPayPeriodCommentPost(timeCardCommentAddRequestV2?: TimeCardCommentAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPayPeriodCommentPost(timeCardCommentAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Change a placeholder\'s OtherHours payment status. Transitioning to Approved creates the  linked OtherHours row (honouring the optional Minutes override + the PayTypesForHours and  accrual-balance gates); any other status removes the linked row; the stored status set again  is a no-op. Ports LegacyApp  `OtherHoursForm.placeholdersGrid_CellValueChanged` (OtherHoursForm.cs:1318-1427); the  legacy WinApp had no equivalent web/TaAPI endpoint.
         * @param {number} placeholderId
         * @param {SchedulePlaceholderPaymentStatusUpdateRequestV2} [schedulePlaceholderPaymentStatusUpdateRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut(placeholderId: number, schedulePlaceholderPaymentStatusUpdateRequestV2?: SchedulePlaceholderPaymentStatusUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut(placeholderId, schedulePlaceholderPaymentStatusUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Add a new schedule placeholder for the employee. Replaces taApi  `POST /api/TimeCard/PlaceHolder`.
         * @param {SchedulePlaceholderAddRequestV2} [schedulePlaceholderAddRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPlaceholderPost(schedulePlaceholderAddRequestV2?: SchedulePlaceholderAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPlaceholderPost(schedulePlaceholderAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Edit a placeholder\'s payment status from the Other Hours window (SPD-5725); only the  transition from the stored status acts, and pay type and hours apply when approving. A save  that sends the status the row was loaded with gets 409 when that status moved meanwhile.  Approving converts the  placeholder into an OtherHours row on the timecard; moving the status away from Approved  removes the linked row again. Mirrors the LegacyApp Other Hours window\'s placeholders grid  (OtherHoursForm.cs:1318-1427). Authorization matches the sibling placeholder endpoints:  class-level CustomJwt plus the service-level facility-role gates (HoursAdd + HoursDelete +  PlaceholderOtherHoursPaymentStatusType) — a caller with no facility authorization resolves a  null role there and gets 403.
         * @param {SchedulePlaceholderUpdateRequestV2} [schedulePlaceholderUpdateRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPlaceholderPut(schedulePlaceholderUpdateRequestV2?: SchedulePlaceholderUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftsBusinessObjectsResponseTimeCardSchedulePlaceholderResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPlaceholderPut(schedulePlaceholderUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Schedule placeholders for the supplied employee. The list is pay-period-scoped  (legacy contract): StartDate/EndDate select WHICH period(s) — they are snapped  outward to full pay-period boundaries, so any date inside the viewed period returns  the whole period. Omitting both defaults to the working pay period. Replaces taApi  `GET /api/TimeCard/PlaceHolder/{employeeId}`.
         * @param {number} employeeId
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {boolean} [payableWithOtherHoursOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardPlaceholdersEmployeeIdGet(employeeId: number, startDate?: string, endDate?: string, payableWithOtherHoursOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenShiftsBusinessObjectsResponseTimeCardSchedulePlaceholderResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardPlaceholdersEmployeeIdGet(employeeId, startDate, endDate, payableWithOtherHoursOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary UI-helper: returns whether the \"Recalculate\" button on the timecard main tab should  be enabled for the supplied (employee, pay-period). Replaces the legacy TaAPI  `PATCH /api/Employee/{id}/WorkingPayPeriod/{pkPayPeriodId}` — the FE only consumed  `isEnabled` from that response, and the PATCH\'s in-memory working-pay-period  side effect has no equivalent in stateless SaaSAPI.
         * @param {number} employeeId
         * @param {number} payPeriodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet(employeeId: number, payPeriodId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecalculateButtonStateResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet(employeeId, payPeriodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Trigger a full timecard recompute for the supplied employee. Replaces taApi  `POST /api/TimeCard/ReCalculateTimecard`.
         * @param {ReCalculateTimecardRequestV2} [reCalculateTimecardRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimecardRecomputePost(reCalculateTimecardRequestV2?: ReCalculateTimecardRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimecardRecomputePost(reCalculateTimecardRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimeCardApi - factory interface
 * @export
 */
export const TimeCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeCardApiFp(configuration)
    return {
        /**
         *
         * @summary Per-exception-type counts for a given pay date. Replaces taApi  `GET /api/TimeCard/DailyExceptionCounts`.
         * @param {TimeCardApiApiV2TimecardDailyExceptionCountsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardDailyExceptionCountsGet(requestParameters: TimeCardApiApiV2TimecardDailyExceptionCountsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.apiV2TimecardDailyExceptionCountsGet(requestParameters.date, requestParameters.graceMinutes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Per-employee exception details for a given (exception type, pay date). Replaces  taApi `GET /api/TimeCard/DailyExceptionDetails`.
         * @param {TimeCardApiApiV2TimecardDailyExceptionDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardDailyExceptionDetailsGet(requestParameters: TimeCardApiApiV2TimecardDailyExceptionDetailsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeExceptionMinutesResponseV2>> {
            return localVarFp.apiV2TimecardDailyExceptionDetailsGet(requestParameters.exceptionTypeId, requestParameters.date, requestParameters.graceMinutes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the static and configuration-based definitions used to render a time card:  the department labor-level designation plus dictionaries of exception, hour, and  comment types. Replaces the legacy  `/api/EntityList/{LaborLevelDesignations,ExceptionTypes,HoursTypes,CommentTypes}`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardDefinitionsGet(options?: AxiosRequestConfig): AxiosPromise<TimeCardDefinitionsResponse> {
            return localVarFp.apiV2TimecardDefinitionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the consolidated time-card payload (punches, hours, exceptions, comments,  holidays) for a single employee within the supplied date range. Falls back to the  working pay period when start/end are omitted. Replaces the legacy  `/api/Punch`, `/api/Hour`, `/api/Hour/OtherHours`,  `/api/Hour/OtherHoursForActualDate`, `/api/Employee/EmployeeHolidays`,  `/api/Exceptions`, and `/api/TimeCard/PayDateComment` endpoints.  Each entry in `PunchNotifications` carries a !:PunchNotificationType.  `CalculationNotes` (SPD-5625) is filled for manager-bucket callers only; an employee  viewing their own card gets an empty list.
         * @param {TimeCardApiApiV2TimecardEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardEmployeeIdGet(requestParameters: TimeCardApiApiV2TimecardEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeTimeCardResponse> {
            return localVarFp.apiV2TimecardEmployeeIdGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hideWorkedHours, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the same pay-period data as `GET /api/v2/timecard/{employeeId}`  reorganised as a dictionary keyed by pay date (`yyyy-MM-dd`). Each value is the  list of punch-group entries on that date — one per distinct `PunchGroupNumber`.  Within an entry the hours carry every `HoursType` except dollar-amount entries  (`Dollars` = 99); set `HideWorkedHours` to also suppress worked Other-Hours  (`OtherHoursWorked` = 25). The exceptions are restricted to  `ScheduleWOPunches` = 5 and `MissingPunch` = 6. Each entry\'s  `placeholders` (SPD-5412) carries schedule placeholders for the date (e.g.  legacy-created absences); since placeholders have no punch group they only appear on  the group-0 (ungrouped) entry. Falls back to the working pay period when start/end are  omitted. Each entry in `PunchNotifications` carries a !:PunchNotificationType.
         * @param {TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardEmployeeIdGroupByPayDateGet(requestParameters: TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGetRequest, options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: Array<PayDateGroupEntry>; }> {
            return localVarFp.apiV2TimecardEmployeeIdGroupByPayDateGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hideWorkedHours, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns when punch data was last synced from the facility\'s time clocks (SPD-5401):  the newest LegacyApp `TimeClock/Poll` audit row, falling back to the newest  `RawPunch` download stamp. Facility-wide (no employee id — the value is facility  metadata), SQL-server local time. `lastSyncedFromClock` is `null` when the  facility has never polled a clock. Net-new endpoint; no TaAPI counterpart exists  (TaAPI has no poll surface).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardLastClockSyncGet(options?: AxiosRequestConfig): AxiosPromise<LastClockSyncResponseV2> {
            return localVarFp.apiV2TimecardLastClockSyncGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft-delete a pay-date comment by id, asserting it belongs to the supplied  employee. Replaces taApi `DELETE /api/TimeCard/PayDateComment`.
         * @param {TimeCardApiApiV2TimecardPayDateCommentDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayDateCommentDelete(requestParameters: TimeCardApiApiV2TimecardPayDateCommentDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2TimecardPayDateCommentDelete(requestParameters.employeeId, requestParameters.commentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns PayDate comments in the supplied [start, end] range. Replaces taApi  `GET /api/TimeCard/PayDateComment`.
         * @param {TimeCardApiApiV2TimecardPayDateCommentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayDateCommentGet(requestParameters: TimeCardApiApiV2TimecardPayDateCommentGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<CommentResponseV2>> {
            return localVarFp.apiV2TimecardPayDateCommentGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add (or replace / append) the pay-date comment for the (employee, pay date)  pair. Replaces taApi `POST /api/TimeCard/PayDateComment`.
         * @param {TimeCardApiApiV2TimecardPayDateCommentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayDateCommentPost(requestParameters: TimeCardApiApiV2TimecardPayDateCommentPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2TimecardPayDateCommentPost(requestParameters.timeCardCommentAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary UI-helper: visible/enabled/label state for the pay-period approval button.  Replaces taApi `GET /api/TimeCard/PayPeriodApprovalButtonProperties/{employeeId}`.
         * @param {TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet(requestParameters: TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<PayPeriodApprovalButtonPropertiesResponseV2> {
            return localVarFp.apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Approve the working pay period at the caller\'s TimeCardApprovalLevel. Returns  the post-action button-properties shape. Replaces taApi  `POST /api/TimeCard/PayPeriodApproval/{employeeId}`.
         * @param {TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodApprovalEmployeeIdPost(requestParameters: TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<PayPeriodApprovalButtonPropertiesResponseV2> {
            return localVarFp.apiV2TimecardPayPeriodApprovalEmployeeIdPost(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the caller\'s pay-period comment for the (employee, pay-period start)  pair, or 204 No Content when none. Replaces taApi  `GET /api/TimeCard/PayPeriodComment`.
         * @param {TimeCardApiApiV2TimecardPayPeriodCommentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodCommentGet(requestParameters: TimeCardApiApiV2TimecardPayPeriodCommentGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<CommentResponseV2> {
            return localVarFp.apiV2TimecardPayPeriodCommentGet(requestParameters.employeeId, requestParameters.startDateOfPayPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add (or replace / append) the pay-period comment for the (employee, pay-period  start date) pair. Replaces taApi `POST /api/TimeCard/PayPeriodComment`.
         * @param {TimeCardApiApiV2TimecardPayPeriodCommentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPayPeriodCommentPost(requestParameters: TimeCardApiApiV2TimecardPayPeriodCommentPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2TimecardPayPeriodCommentPost(requestParameters.timeCardCommentAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change a placeholder\'s OtherHours payment status. Transitioning to Approved creates the  linked OtherHours row (honouring the optional Minutes override + the PayTypesForHours and  accrual-balance gates); any other status removes the linked row; the stored status set again  is a no-op. Ports LegacyApp  `OtherHoursForm.placeholdersGrid_CellValueChanged` (OtherHoursForm.cs:1318-1427); the  legacy WinApp had no equivalent web/TaAPI endpoint.
         * @param {TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut(requestParameters: TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut(requestParameters.placeholderId, requestParameters.schedulePlaceholderPaymentStatusUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a new schedule placeholder for the employee. Replaces taApi  `POST /api/TimeCard/PlaceHolder`.
         * @param {TimeCardApiApiV2TimecardPlaceholderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholderPost(requestParameters: TimeCardApiApiV2TimecardPlaceholderPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2TimecardPlaceholderPost(requestParameters.schedulePlaceholderAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit a placeholder\'s payment status from the Other Hours window (SPD-5725); only the  transition from the stored status acts, and pay type and hours apply when approving. A save  that sends the status the row was loaded with gets 409 when that status moved meanwhile.  Approving converts the  placeholder into an OtherHours row on the timecard; moving the status away from Approved  removes the linked row again. Mirrors the LegacyApp Other Hours window\'s placeholders grid  (OtherHoursForm.cs:1318-1427). Authorization matches the sibling placeholder endpoints:  class-level CustomJwt plus the service-level facility-role gates (HoursAdd + HoursDelete +  PlaceholderOtherHoursPaymentStatusType) — a caller with no facility authorization resolves a  null role there and gets 403.
         * @param {TimeCardApiApiV2TimecardPlaceholderPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholderPut(requestParameters: TimeCardApiApiV2TimecardPlaceholderPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OpenShiftsBusinessObjectsResponseTimeCardSchedulePlaceholderResponseV2> {
            return localVarFp.apiV2TimecardPlaceholderPut(requestParameters.schedulePlaceholderUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule placeholders for the supplied employee. The list is pay-period-scoped  (legacy contract): StartDate/EndDate select WHICH period(s) — they are snapped  outward to full pay-period boundaries, so any date inside the viewed period returns  the whole period. Omitting both defaults to the working pay period. Replaces taApi  `GET /api/TimeCard/PlaceHolder/{employeeId}`.
         * @param {TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardPlaceholdersEmployeeIdGet(requestParameters: TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<OpenShiftsBusinessObjectsResponseTimeCardSchedulePlaceholderResponseV2>> {
            return localVarFp.apiV2TimecardPlaceholdersEmployeeIdGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.payableWithOtherHoursOnly, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary UI-helper: returns whether the \"Recalculate\" button on the timecard main tab should  be enabled for the supplied (employee, pay-period). Replaces the legacy TaAPI  `PATCH /api/Employee/{id}/WorkingPayPeriod/{pkPayPeriodId}` — the FE only consumed  `isEnabled` from that response, and the PATCH\'s in-memory working-pay-period  side effect has no equivalent in stateless SaaSAPI.
         * @param {TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet(requestParameters: TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<RecalculateButtonStateResponseV2> {
            return localVarFp.apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet(requestParameters.employeeId, requestParameters.payPeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Trigger a full timecard recompute for the supplied employee. Replaces taApi  `POST /api/TimeCard/ReCalculateTimecard`.
         * @param {TimeCardApiApiV2TimecardRecomputePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimecardRecomputePost(requestParameters: TimeCardApiApiV2TimecardRecomputePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2TimecardRecomputePost(requestParameters.reCalculateTimecardRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2TimecardDailyExceptionCountsGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardDailyExceptionCountsGetRequest
 */
export interface TimeCardApiApiV2TimecardDailyExceptionCountsGetRequest {
    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardDailyExceptionCountsGet
     */
    readonly date?: string

    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardDailyExceptionCountsGet
     */
    readonly graceMinutes?: number
}

/**
 * Request parameters for apiV2TimecardDailyExceptionDetailsGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardDailyExceptionDetailsGetRequest
 */
export interface TimeCardApiApiV2TimecardDailyExceptionDetailsGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardDailyExceptionDetailsGet
     */
    readonly exceptionTypeId?: number

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardDailyExceptionDetailsGet
     */
    readonly date?: string

    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardDailyExceptionDetailsGet
     */
    readonly graceMinutes?: number
}

/**
 * Request parameters for apiV2TimecardEmployeeIdGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardEmployeeIdGetRequest
 */
export interface TimeCardApiApiV2TimecardEmployeeIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGet
     */
    readonly employeeId: number

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGet
     */
    readonly startDate?: string

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGet
     */
    readonly endDate?: string

    /**
     *
     * @type {boolean}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGet
     */
    readonly hideWorkedHours?: boolean
}

/**
 * Request parameters for apiV2TimecardEmployeeIdGroupByPayDateGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGetRequest
 */
export interface TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGet
     */
    readonly employeeId: number

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGet
     */
    readonly startDate?: string

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGet
     */
    readonly endDate?: string

    /**
     *
     * @type {boolean}
     * @memberof TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGet
     */
    readonly hideWorkedHours?: boolean
}

/**
 * Request parameters for apiV2TimecardPayDateCommentDelete operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayDateCommentDeleteRequest
 */
export interface TimeCardApiApiV2TimecardPayDateCommentDeleteRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPayDateCommentDelete
     */
    readonly employeeId?: number

    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPayDateCommentDelete
     */
    readonly commentId?: number
}

/**
 * Request parameters for apiV2TimecardPayDateCommentGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayDateCommentGetRequest
 */
export interface TimeCardApiApiV2TimecardPayDateCommentGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPayDateCommentGet
     */
    readonly employeeId?: number

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardPayDateCommentGet
     */
    readonly startDate?: string

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardPayDateCommentGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiV2TimecardPayDateCommentPost operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayDateCommentPostRequest
 */
export interface TimeCardApiApiV2TimecardPayDateCommentPostRequest {
    /**
     *
     * @type {TimeCardCommentAddRequestV2}
     * @memberof TimeCardApiApiV2TimecardPayDateCommentPost
     */
    readonly timeCardCommentAddRequestV2?: TimeCardCommentAddRequestV2
}

/**
 * Request parameters for apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGetRequest
 */
export interface TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for apiV2TimecardPayPeriodApprovalEmployeeIdPost operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPostRequest
 */
export interface TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPostRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPost
     */
    readonly employeeId: number
}

/**
 * Request parameters for apiV2TimecardPayPeriodCommentGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayPeriodCommentGetRequest
 */
export interface TimeCardApiApiV2TimecardPayPeriodCommentGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPayPeriodCommentGet
     */
    readonly employeeId?: number

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardPayPeriodCommentGet
     */
    readonly startDateOfPayPeriod?: string
}

/**
 * Request parameters for apiV2TimecardPayPeriodCommentPost operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPayPeriodCommentPostRequest
 */
export interface TimeCardApiApiV2TimecardPayPeriodCommentPostRequest {
    /**
     *
     * @type {TimeCardCommentAddRequestV2}
     * @memberof TimeCardApiApiV2TimecardPayPeriodCommentPost
     */
    readonly timeCardCommentAddRequestV2?: TimeCardCommentAddRequestV2
}

/**
 * Request parameters for apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPutRequest
 */
export interface TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPutRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut
     */
    readonly placeholderId: number

    /**
     *
     * @type {SchedulePlaceholderPaymentStatusUpdateRequestV2}
     * @memberof TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut
     */
    readonly schedulePlaceholderPaymentStatusUpdateRequestV2?: SchedulePlaceholderPaymentStatusUpdateRequestV2
}

/**
 * Request parameters for apiV2TimecardPlaceholderPost operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPlaceholderPostRequest
 */
export interface TimeCardApiApiV2TimecardPlaceholderPostRequest {
    /**
     *
     * @type {SchedulePlaceholderAddRequestV2}
     * @memberof TimeCardApiApiV2TimecardPlaceholderPost
     */
    readonly schedulePlaceholderAddRequestV2?: SchedulePlaceholderAddRequestV2
}

/**
 * Request parameters for apiV2TimecardPlaceholderPut operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPlaceholderPutRequest
 */
export interface TimeCardApiApiV2TimecardPlaceholderPutRequest {
    /**
     *
     * @type {SchedulePlaceholderUpdateRequestV2}
     * @memberof TimeCardApiApiV2TimecardPlaceholderPut
     */
    readonly schedulePlaceholderUpdateRequestV2?: SchedulePlaceholderUpdateRequestV2
}

/**
 * Request parameters for apiV2TimecardPlaceholdersEmployeeIdGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGetRequest
 */
export interface TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGet
     */
    readonly employeeId: number

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGet
     */
    readonly startDate?: string

    /**
     *
     * @type {string}
     * @memberof TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGet
     */
    readonly endDate?: string

    /**
     *
     * @type {boolean}
     * @memberof TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGet
     */
    readonly payableWithOtherHoursOnly?: boolean
}

/**
 * Request parameters for apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGetRequest
 */
export interface TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGetRequest {
    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet
     */
    readonly employeeId: number

    /**
     *
     * @type {number}
     * @memberof TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet
     */
    readonly payPeriodId: number
}

/**
 * Request parameters for apiV2TimecardRecomputePost operation in TimeCardApi.
 * @export
 * @interface TimeCardApiApiV2TimecardRecomputePostRequest
 */
export interface TimeCardApiApiV2TimecardRecomputePostRequest {
    /**
     *
     * @type {ReCalculateTimecardRequestV2}
     * @memberof TimeCardApiApiV2TimecardRecomputePost
     */
    readonly reCalculateTimecardRequestV2?: ReCalculateTimecardRequestV2
}

/**
 * TimeCardApi - object-oriented interface
 * @export
 * @class TimeCardApi
 * @extends {BaseAPI}
 */
export class TimeCardApi extends BaseAPI {
    /**
     *
     * @summary Per-exception-type counts for a given pay date. Replaces taApi  `GET /api/TimeCard/DailyExceptionCounts`.
     * @param {TimeCardApiApiV2TimecardDailyExceptionCountsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardDailyExceptionCountsGet(requestParameters: TimeCardApiApiV2TimecardDailyExceptionCountsGetRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardDailyExceptionCountsGet(requestParameters.date, requestParameters.graceMinutes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Per-employee exception details for a given (exception type, pay date). Replaces  taApi `GET /api/TimeCard/DailyExceptionDetails`.
     * @param {TimeCardApiApiV2TimecardDailyExceptionDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardDailyExceptionDetailsGet(requestParameters: TimeCardApiApiV2TimecardDailyExceptionDetailsGetRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardDailyExceptionDetailsGet(requestParameters.exceptionTypeId, requestParameters.date, requestParameters.graceMinutes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Returns the static and configuration-based definitions used to render a time card:  the department labor-level designation plus dictionaries of exception, hour, and  comment types. Replaces the legacy  `/api/EntityList/{LaborLevelDesignations,ExceptionTypes,HoursTypes,CommentTypes}`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardDefinitionsGet(options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardDefinitionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Returns the consolidated time-card payload (punches, hours, exceptions, comments,  holidays) for a single employee within the supplied date range. Falls back to the  working pay period when start/end are omitted. Replaces the legacy  `/api/Punch`, `/api/Hour`, `/api/Hour/OtherHours`,  `/api/Hour/OtherHoursForActualDate`, `/api/Employee/EmployeeHolidays`,  `/api/Exceptions`, and `/api/TimeCard/PayDateComment` endpoints.  Each entry in `PunchNotifications` carries a !:PunchNotificationType.  `CalculationNotes` (SPD-5625) is filled for manager-bucket callers only; an employee  viewing their own card gets an empty list.
     * @param {TimeCardApiApiV2TimecardEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardEmployeeIdGet(requestParameters: TimeCardApiApiV2TimecardEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardEmployeeIdGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hideWorkedHours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Returns the same pay-period data as `GET /api/v2/timecard/{employeeId}`  reorganised as a dictionary keyed by pay date (`yyyy-MM-dd`). Each value is the  list of punch-group entries on that date — one per distinct `PunchGroupNumber`.  Within an entry the hours carry every `HoursType` except dollar-amount entries  (`Dollars` = 99); set `HideWorkedHours` to also suppress worked Other-Hours  (`OtherHoursWorked` = 25). The exceptions are restricted to  `ScheduleWOPunches` = 5 and `MissingPunch` = 6. Each entry\'s  `placeholders` (SPD-5412) carries schedule placeholders for the date (e.g.  legacy-created absences); since placeholders have no punch group they only appear on  the group-0 (ungrouped) entry. Falls back to the working pay period when start/end are  omitted. Each entry in `PunchNotifications` carries a !:PunchNotificationType.
     * @param {TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardEmployeeIdGroupByPayDateGet(requestParameters: TimeCardApiApiV2TimecardEmployeeIdGroupByPayDateGetRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardEmployeeIdGroupByPayDateGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.hideWorkedHours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Returns when punch data was last synced from the facility\'s time clocks (SPD-5401):  the newest LegacyApp `TimeClock/Poll` audit row, falling back to the newest  `RawPunch` download stamp. Facility-wide (no employee id — the value is facility  metadata), SQL-server local time. `lastSyncedFromClock` is `null` when the  facility has never polled a clock. Net-new endpoint; no TaAPI counterpart exists  (TaAPI has no poll surface).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardLastClockSyncGet(options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardLastClockSyncGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Soft-delete a pay-date comment by id, asserting it belongs to the supplied  employee. Replaces taApi `DELETE /api/TimeCard/PayDateComment`.
     * @param {TimeCardApiApiV2TimecardPayDateCommentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayDateCommentDelete(requestParameters: TimeCardApiApiV2TimecardPayDateCommentDeleteRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayDateCommentDelete(requestParameters.employeeId, requestParameters.commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Returns PayDate comments in the supplied [start, end] range. Replaces taApi  `GET /api/TimeCard/PayDateComment`.
     * @param {TimeCardApiApiV2TimecardPayDateCommentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayDateCommentGet(requestParameters: TimeCardApiApiV2TimecardPayDateCommentGetRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayDateCommentGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add (or replace / append) the pay-date comment for the (employee, pay date)  pair. Replaces taApi `POST /api/TimeCard/PayDateComment`.
     * @param {TimeCardApiApiV2TimecardPayDateCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayDateCommentPost(requestParameters: TimeCardApiApiV2TimecardPayDateCommentPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayDateCommentPost(requestParameters.timeCardCommentAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary UI-helper: visible/enabled/label state for the pay-period approval button.  Replaces taApi `GET /api/TimeCard/PayPeriodApprovalButtonProperties/{employeeId}`.
     * @param {TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet(requestParameters: TimeCardApiApiV2TimecardPayPeriodApprovalButtonEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayPeriodApprovalButtonEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Approve the working pay period at the caller\'s TimeCardApprovalLevel. Returns  the post-action button-properties shape. Replaces taApi  `POST /api/TimeCard/PayPeriodApproval/{employeeId}`.
     * @param {TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayPeriodApprovalEmployeeIdPost(requestParameters: TimeCardApiApiV2TimecardPayPeriodApprovalEmployeeIdPostRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayPeriodApprovalEmployeeIdPost(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Returns the caller\'s pay-period comment for the (employee, pay-period start)  pair, or 204 No Content when none. Replaces taApi  `GET /api/TimeCard/PayPeriodComment`.
     * @param {TimeCardApiApiV2TimecardPayPeriodCommentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayPeriodCommentGet(requestParameters: TimeCardApiApiV2TimecardPayPeriodCommentGetRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayPeriodCommentGet(requestParameters.employeeId, requestParameters.startDateOfPayPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add (or replace / append) the pay-period comment for the (employee, pay-period  start date) pair. Replaces taApi `POST /api/TimeCard/PayPeriodComment`.
     * @param {TimeCardApiApiV2TimecardPayPeriodCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPayPeriodCommentPost(requestParameters: TimeCardApiApiV2TimecardPayPeriodCommentPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPayPeriodCommentPost(requestParameters.timeCardCommentAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Change a placeholder\'s OtherHours payment status. Transitioning to Approved creates the  linked OtherHours row (honouring the optional Minutes override + the PayTypesForHours and  accrual-balance gates); any other status removes the linked row; the stored status set again  is a no-op. Ports LegacyApp  `OtherHoursForm.placeholdersGrid_CellValueChanged` (OtherHoursForm.cs:1318-1427); the  legacy WinApp had no equivalent web/TaAPI endpoint.
     * @param {TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut(requestParameters: TimeCardApiApiV2TimecardPlaceholderPlaceholderIdPaymentStatusPutRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPlaceholderPlaceholderIdPaymentStatusPut(requestParameters.placeholderId, requestParameters.schedulePlaceholderPaymentStatusUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Add a new schedule placeholder for the employee. Replaces taApi  `POST /api/TimeCard/PlaceHolder`.
     * @param {TimeCardApiApiV2TimecardPlaceholderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPlaceholderPost(requestParameters: TimeCardApiApiV2TimecardPlaceholderPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPlaceholderPost(requestParameters.schedulePlaceholderAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Edit a placeholder\'s payment status from the Other Hours window (SPD-5725); only the  transition from the stored status acts, and pay type and hours apply when approving. A save  that sends the status the row was loaded with gets 409 when that status moved meanwhile.  Approving converts the  placeholder into an OtherHours row on the timecard; moving the status away from Approved  removes the linked row again. Mirrors the LegacyApp Other Hours window\'s placeholders grid  (OtherHoursForm.cs:1318-1427). Authorization matches the sibling placeholder endpoints:  class-level CustomJwt plus the service-level facility-role gates (HoursAdd + HoursDelete +  PlaceholderOtherHoursPaymentStatusType) — a caller with no facility authorization resolves a  null role there and gets 403.
     * @param {TimeCardApiApiV2TimecardPlaceholderPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPlaceholderPut(requestParameters: TimeCardApiApiV2TimecardPlaceholderPutRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPlaceholderPut(requestParameters.schedulePlaceholderUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Schedule placeholders for the supplied employee. The list is pay-period-scoped  (legacy contract): StartDate/EndDate select WHICH period(s) — they are snapped  outward to full pay-period boundaries, so any date inside the viewed period returns  the whole period. Omitting both defaults to the working pay period. Replaces taApi  `GET /api/TimeCard/PlaceHolder/{employeeId}`.
     * @param {TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardPlaceholdersEmployeeIdGet(requestParameters: TimeCardApiApiV2TimecardPlaceholdersEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardPlaceholdersEmployeeIdGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, requestParameters.payableWithOtherHoursOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary UI-helper: returns whether the \"Recalculate\" button on the timecard main tab should  be enabled for the supplied (employee, pay-period). Replaces the legacy TaAPI  `PATCH /api/Employee/{id}/WorkingPayPeriod/{pkPayPeriodId}` — the FE only consumed  `isEnabled` from that response, and the PATCH\'s in-memory working-pay-period  side effect has no equivalent in stateless SaaSAPI.
     * @param {TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet(requestParameters: TimeCardApiApiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGetRequest, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardRecalculateButtonEmployeeIdPayPeriodIdGet(requestParameters.employeeId, requestParameters.payPeriodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Trigger a full timecard recompute for the supplied employee. Replaces taApi  `POST /api/TimeCard/ReCalculateTimecard`.
     * @param {TimeCardApiApiV2TimecardRecomputePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeCardApi
     */
    public apiV2TimecardRecomputePost(requestParameters: TimeCardApiApiV2TimecardRecomputePostRequest = {}, options?: AxiosRequestConfig) {
        return TimeCardApiFp(this.configuration).apiV2TimecardRecomputePost(requestParameters.reCalculateTimecardRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}
